import axios from './axiosConfig';
import useUnload from "../components/UseUnload";

const onWindowReload  = async(examId,examDetail,setWindowSwitch,setTestData,windowSwitchCount,testData) => {
  window.onbeforeunload = function () {
    let testDataUnload = window.localStorage.getItem(examId)
    if(testDataUnload == null) {
      let remainingTime = window.localStorage.getItem('remainingTime')
      examDetail[0].time_remaining = remainingTime;
      examDetail[0].webproctoringcount -= windowSwitchCount;
      if(examDetail[0].defaultZeroProctorCheck != true){
        if(examDetail[0].webproctoringcount == 0) {
          examDetail[0].webproctoringzero = true;
        }
      }
    
      
      let stringifyExamDetail = JSON.stringify(examDetail);
      let encodedExamDetail = encodeURIComponent(btoa(encodeURIComponent(stringifyExamDetail)))
  
      let stringifyQuesData = JSON.stringify(testData);
      let encodedQuesData = encodeURIComponent(btoa(encodeURIComponent(stringifyQuesData)))
  
      axios.post('/test/answeredQuestions', {
        headers: {
          'Access-Control-Allow-Origin': '*',
        }, examDetail: encodedExamDetail, id: examDetail[0].id, quesData: encodedQuesData
      }).then(result => { 
        setWindowSwitch(0)       
        let decode = decodeURIComponent(atob(decodeURIComponent(result.data.examData)))
        let stringifyDecode = JSON.stringify(decode);
        let parseExamData = JSON.parse(stringifyDecode);
        let examDetail = JSON.parse(parseExamData).examDetail;
        let testData = JSON.parse(parseExamData).quesData;
        setTestData({quesData : testData , examDetail: examDetail})
        window.localStorage.removeItem(examId);
        window.localStorage.removeItem('remainingTime')
      }).catch(err => {
        console.log('error', err);
      })
    }
    else if (testDataUnload !== null) {
      let decodedTestData = decodeURIComponent(atob(decodeURIComponent(testDataUnload)))
  
      let parsedData = JSON.parse(decodedTestData);
      let examDetail = parsedData.examDetail;
      let testData = parsedData.quesData;
      
      if (parsedData[0]) {
        let remainingTime = window.localStorage.getItem('remainingTime')
        parsedData[0].examDetail[0].time_remaining = remainingTime;
       parsedData[0].examDetail[0].webproctoringcount -= windowSwitchCount;
       if(parsedData[0].examDetail[0].defaultZeroProctorCheck != true){
        if(parsedData[0].examDetail[0].webproctoringcount === 0){
          parsedData[0].examDetail[0].webproctoringzero = true;
         }
       }
      
       setWindowSwitch(0)
       let stringifyExamDetail = JSON.stringify(parsedData[0].examDetail)
        var encodedExamDetail = encodeURIComponent(btoa(encodeURIComponent(stringifyExamDetail)))
  
        let stringifyQuesData = JSON.stringify(parsedData[0].quesData);
        var encodedQuesData = encodeURIComponent(btoa(encodeURIComponent(stringifyQuesData)))
  
      }
      else {
        let remainingTime = window.localStorage.getItem('remainingTime')
        parsedData.examDetail[0].time_remaining = remainingTime;
        parsedData.examDetail[0].webproctoringcount -= windowSwitchCount;
        if(parsedData.examDetail[0].defaultZeroProctorCheck!= true){
        if (parsedData.examDetail[0].webproctoringcount === 0) {
          parsedData.examDetail[0].webproctoringzero = true;
        }
        }
        setWindowSwitch(0)
        let stringifyExamDetailNew = JSON.stringify(parsedData.examDetail);
        var encodedExamDetailNew = encodeURIComponent(btoa(encodeURIComponent(stringifyExamDetailNew)))

        let stringifyQuesDataNew = JSON.stringify(parsedData.quesData);
        var encodedQuesDataNew = encodeURIComponent(btoa(encodeURIComponent(stringifyQuesDataNew)));
      }
      axios.post('/test/answeredQuestions', {
        headers: {
          'Access-Control-Allow-Origin': '*',
        }, examDetail: parsedData[0] ? encodedExamDetail : encodedExamDetailNew, id: parsedData[0] ? parsedData[0].examDetail[0].id : parsedData.examDetail[0].id, quesData: parsedData[0] ? encodedQuesData : encodedQuesDataNew
      }).then(result => { 
        setWindowSwitch(0)       
        let decode = decodeURIComponent(atob(decodeURIComponent(result.data.examData)))
        let stringifyDecode = JSON.stringify(decode);
        let parseExamData = JSON.parse(stringifyDecode);
        let examDetail = JSON.parse(parseExamData).examDetail;
        let testData = JSON.parse(parseExamData).quesData;
        setTestData({quesData : testData , examDetail: examDetail})
        window.localStorage.removeItem(examId);
        window.localStorage.removeItem('remainingTime')
      }).catch(err => {
        console.log('error', err);
      })
    }
  
    return "Data will be lost if you leave the page, are you sure?";
  };
  useUnload( e => {
  });

}

export default onWindowReload;